import { faCircleCheck } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { SIcon } from './styles/GridCellBoolean.styled';

interface IProps {
  isActive: boolean;
}

const GridCellBoolean: React.FC<IProps> = ({ isActive }) => {
  return (
    <td colSpan={1} role="gridcell" aria-selected="false">
      <SIcon active={isActive}>
        <FontAwesomeIcon icon={faCircleCheck} />
      </SIcon>
    </td>
  );
};

export default GridCellBoolean;
